<template>
  <div class="row">
    <div class="col-12">
      <h2 class="titre">
        Ajouter catégorie
      </h2>
      <EnteteTableValeurDossier ref="enteteTableValeurDossier" :isModifier="false"
                                :isGenre="true" :isNature="true" :isType="true"/>
      <RoleSecuriteTV ref="roleSecuriteTV" :isModifier="false"/>
      <FrancaisComposant ref="francaisComposant" :isModifier="false"/>
      <Justification ref="justification"/>
      <div class="row pt-2">
        <div class="col">
          <div v-if="enregistrementEnCours == false">
            <Button type="button" label="Ajouter" @click="ajouter"/>
          </div>
          <div v-else>
            <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
          </div>
        </div>
        <div class="col">
          <Button type="button" label="Annuler" @click="fermer"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from "axios";
import Justification from "@/components/pilotage/ClassementDeDossier/InformationJustification.vue";
import FrancaisComposant from "@/components/pilotage/ClassementDeDossier/Ajouter/FrancaisComposant.vue";
import EnteteTableValeurDossier from "@/components/pilotage/ClassementDeDossier/Ajouter/EnteteTableValeurDossier.vue";
import RoleSecuriteTV from "@/components/pilotage/ClassementDeDossier/Ajouter/RoleSecuriteTV.vue";

export default {
  name: "AjouterCategorie",
  components: {RoleSecuriteTV, EnteteTableValeurDossier, Justification, FrancaisComposant},
  computed: {
    ...mapGetters({
        jeton: 'cardex/jeton',
        profil: 'cardex/profil',
        decisionTableValeur: 'pilotage/decisionTableValeur',
    })
  },
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Ajouter Catégorie");
  },
  data() {
    return {
      isRechercheDataLoading: false,
      enregistrementEnCours: false,
      ascendantCle: null,
      tableValeurLocal: {},
      code: "Categorie",
    }
  },
  methods: {
    ajouter() {
      this.enregistrementEnCours = true;
      this.assignerListeTV();
      this.$store.dispatch('pilotage/ajouterTableValeurAction', {
          ascendantCle: this.ascendantCle,
          tableValeur: this.tableValeurLocal
      }).then((res) => {
        this.enregistrementEnCours = false;
        this.$root.$refs.messagesComp.messagesList = res.data.messages;
      }).catch(err => {
        this.$toast.add({
            severity: 'error',
            summary: 'Sauvegarder',
            detail: `Erreur lors de l'enregistrement du type: ${err}`,
            life: 6000
        })
        this.enregistrementEnCours = false;
      })
    },
    assignerListeTV() {
        this.ascendantCle = Number(this.$refs.enteteTableValeurDossier.getValeurLocal().type);
        this.tableValeurLocal.tableValeurVO = this.$refs.enteteTableValeurDossier.getTableValeurLocal();
        this.tableValeurLocal.tableValeurVO.code = this.code;
        this.tableValeurLocal.libelleVO = this.$refs.francaisComposant.getValeurFrancaisLocal();
        this.tableValeurLocal.rolesVO = this.$refs.roleSecuriteTV.getRoleSecuriteTVLocalLocal();
        this.tableValeurLocal.justificationVO = this.$refs.justification.getJustification();
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  }
}
</script>